import Vue from 'vue'
import VueSession from 'vue-session'

Vue.use(VueSession)

export function isLoggedIn() {
  return Vue.prototype.$session.get('user-token')
}